export default function(element) {
    let lists = (element?.tagName === 'UL' || element?.tagName === 'OL') ? [element] : [];
    lists.push(...element.querySelectorAll('ul,ol'));
    if (lists && lists.length > 0) {
        
        lists.forEach(list => {
            let namedByClass = false;
            if (list.classList?.contains('check-mark')) {
                namedByClass = 'check';
            }
            let items = [...list.querySelectorAll('li')];
            let svgUrl = `${element.dataset.svg || element.dataset.svgUrl || '~/images/svg.svg'}`;
            let name = namedByClass || element.dataset.icon || '';
            if (name) {
                items.forEach(item => {
                    if (!item) {
                        return;
                    }
                    if (!item.firstElementChild?.classList?.contains('c-list__icon-wrapper') && !item.firstElementChild?.classList?.contains('c-icon')) {
                        item.innerHTML = `<span class=c-list__icon-wrapper><svg focusable="false" aria-hidden="true" class="c-icon c-icon--${name}"><title>${name}</title><use xlink:href="${svgUrl}#${name}" /></svg></span><div class=c-list__item-wrapper>${item.innerHTML}</div>`
                    }
                });
                list.classList.add('c-list', 'c-list--icon');
                list.classList.remove('c-list--unstyled');
            }
        });
    }
}

